/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Stake_Switch_To_UsdInputs */



/**
* | output |
* | --- |
* | "Switch Stake to USD" |
*
* @param {Metric_Stake_Switch_To_UsdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_stake_switch_to_usd = /** @type {((inputs?: Metric_Stake_Switch_To_UsdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Stake_Switch_To_UsdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch Stake to USD")
});